var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"personal-info daily-login"},[_c('div',{staticClass:"mission-content",staticStyle:{"width":"90%"}},[_c('DailyLogin',{attrs:{"message":"2"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88eea2dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/dailyLogin.vue
// module id = null
// module chunks = 